import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
const $=window.$;

class Ecoach extends Component {
	constructor(props) {
		super(props);
		this.state={
			ecoachlist : [],
			faqlist:[],
			task_question_count:'',
			faq_questions:[],
			txtQuestion:''
    };
		this.fnAskquestionSubmit = this.fnAskquestionSubmit.bind(this);
		this.fnViewAnswerRate = this.fnViewAnswerRate.bind(this);
	}
	getTabs(){
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

    }
		getCoach(){
				let learnerID = Common.getUserData("id", true);
				let productID = Common.getUserData("productID", true);
				//alert(learnerID);
				fetch(Config.domainUrl+'ecoach/ecoachlist', {
	        method: 'POST',
	        headers: {
	          'Accept': 'application/json',
	          'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
	        },
	          body: JSON.stringify({
			       productID:productID,
						 learnerID:learnerID
	          })
	        }).then((response) => response.json())
	       .then((responseJson) => {
	          //alert(responseJson);
						let faqlist=(responseJson.ecoachlist.faqlist!=undefined) ? responseJson.ecoachlist.faqlist : '';
						let task_question_count=(responseJson.ecoachlist.task_question_count!=undefined) ? responseJson.ecoachlist.task_question_count : '';
						let faq_questions=(responseJson.ecoachlist.faq_questions!=undefined) ? responseJson.ecoachlist.faq_questions : '';
						//alert(task_question_count);

						this.setState({
							ecoachlist: responseJson.ecoachlist,
							faqlist: faqlist,
							task_question_count:task_question_count,
							faq_questions:faq_questions,

						});
						Common.downTabClose();
	   		 });
		}

		fnChange(e){
			let tabdiv=e;
			$(".accordion_in").removeClass('acc_active');
			if($('.answer'+tabdiv+':visible').length == 0)
			{
					$(".allfaqs").hide();
					$(".mainfaq"+tabdiv).addClass('acc_active');
					$(".answer"+tabdiv).show();
			} else {
				$(".answer"+tabdiv).hide();
			}
	  }
		fnAskquestion(){
			if($('#tr_askEC:visible').length == 0){
				$('#tr_askEC').show();
			} else {
				$('#tr_askEC').hide();
			}
		}
		fnAskquestionSubmit(){
				let learnerID = Common.getUserData("id", true);
				let corporateID = Common.getUserData("corporateID", true);
				let productName = Common.getUserData("productName", true);
				let formVal = $("#txtQuestion").val();

				if(formVal !=''){
					Common.reactLoader("show", "Please wait...");
					fetch(Config.domainUrl+'ecoach/askquestion', {
				   method: 'POST',
				   headers: {
				     'Accept': 'application/json',
				     'Content-Type': 'application/json',
					 'Authorization':'Bearer ' +Common.getTokenData()
				    },
						body: JSON.stringify({
				      learnerID: learnerID,
							formVal:formVal,
							corporateID:corporateID,
							productName:productName
				    })
				    })
				   .then((responseJson) => {
				     	Common.reactLoader("hide");
				     	 if (responseJson.status == 0) {
					        Common.message(responseJson.message, responseJson.errors, "error");
					     } else {
					        $("#txtQuestion").val('');
					        Common.message("", 'Your question has been sent to your E Coach. You will get reply in your message inbox.', "success");				       
					     }
							//alert(responseJson.ecoach_count);
				   });
				} else {
					$('#error_qus').css('display','block');
				}
		   }
	fnViewAnswerRate(e){
		//let pdata =  $('#qtoec_rate_form'+e).serialize();
		let cmbRate =$('#cmbRate'+e).val();
		let formData = new FormData(), pdata = $('#qtoec_rate_form'+e).serializeArray();
		formData.append("learnerID", Common.getUserData("id", true));
		formData.append("productName",Common.getUserData("productName", true));
		pdata.map((val)=>{
			formData.append(val.name, val.value);
		});

		Common.reactLoader("show", "Please wait...");
		fetch(Config.domainUrl+'ecoach/viewanswerrate', {
		 method: 'POST',
		 headers: {
			 'Accept': 'application/json',
			 'Authorization':'Bearer ' +Common.getTokenData()
			},
			body: formData
			})
		 .then((responseJson) => {
				Common.reactLoader("hide");

				$('#cmbrating'+e).html(cmbRate);
				$('#ansajax'+e).show();
				$('#ratebox'+e).hide();
		 });
	}
	componentDidMount() {
	 	this.getTabs();
		this.getCoach();
		//Common.showSmallLeftMenu();
	}

		render() {
			const faqcontent=this.state.faqlist.map((key,index)=>{
            return <div key={`faqcontent_${index}`} className={`accordion_in mainfaq${index}`}>
							<div className="acc_head" onClick={(e) =>this.fnChange(index)}><div className="acc_icon_expand"></div><div className="acc_icon_expand"></div>
							<span>{index+1}</span>{key.question}</div>
							<div className={`answer${index} allfaqs acc_content`}  style={{display: 'none'}}>
								<p dangerouslySetInnerHTML={{ __html:key.answer?key.answer:''}} />
								</div>
						</div>
        });

				const faq_questions=this.state.faq_questions.map((key,index)=>{
	            return <div key={`faqques_${index}`}>
							<form name={`qtoec_rate_form${index}`} id={`qtoec_rate_form${index}`} action="javascript:void(0);" method="post" onSubmit={(e) =>this.fnViewAnswerRate(index)}>
							<input type="hidden" name="hidcnt" id="hidcnt" value={`${index}`} />
							<input type="hidden" name={`hidqtoec_id${index}`} id={`hidqtoec_id${index}`} value={key.faq_id_pk} />
							<input type="hidden" name={`hidqtoec_id_pk${index}`} id={`hidqtoec_id_pk${index}`} value={key.faq_id_pk} />
							<input type="hidden" name={`hidquestion${index}`} id={`hidquestion${index}`} value={key.question} />
							<input type="hidden" name={`hidanswer${index}`} id={`hidanswer${index}`} value={(key.answer==null)?'':key.answer} />
							<p className="para-black">{key.question}</p>
							{(key.isanswered==1) ?
							<div><h2 className="titleorng">Your E Coach replied :</h2>
							<div className="orng-box">
								<p dangerouslySetInnerHTML={{ __html:key.answer?key.answer:''}} />
							</div>
							<div className="ecoach-ratings">
								{(key.answered_date!="") ?
								 <div className="ecoach-ratings1">
								 <img border="0" alt="" src={process.env.PUBLIC_URL+'/images/calendar-icon-grn.png'} />Answered on :  {key.answered_date}
								 </div>
								 :
								 <div></div>
								 }
								 {(key.learner_rating!=0) ?
								 <div className="ecoach-ratings2">
								 <img border="0" alt="" src={process.env.PUBLIC_URL+'/images/star-icon-yellow.png'} />Your rating for this answer - <span>{key.learner_rating}/10</span>
								 </div>
								  :
									<div><div id={`ansajax${index}`} style={{display:'none'}}>
									<div className="ecoach-ratings2">
										 <img border="0" alt="" src={process.env.PUBLIC_URL+'/images/star-icon-yellow.png'} />Your rating for this answer - <span><span id={`cmbrating${index}`}></span>/10</span>
										 </div>
									</div>
									<div className="ratebox" id={`ratebox${index}`}>
										<span>Rate this Answer</span>
										<select id={`cmbRate${index}`} name={`cmbRate${index}`}>
											<option value="">--Select--</option>
											<option value="1">1</option>
											<option value="2">2</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6">6</option>
											<option value="7">7</option>
											<option value="8">8</option>
											<option value="9">9</option>
											<option value="10">10</option>
										</select>
										<div id={`div_rate${index}`} className="error"></div>
										<div className="button"><span>
										<input type="submit" name="btnRate" value="Rate" alt="Rate" title="Rate" />
										</span>
										</div>
									</div>
									</div>
								}
							</div>
							</div>
							:
								<div><div className="noecoachans" >Answer yet to be posted.</div></div>
							}

							</form>
							</div>
	        });





		return (
			<section id="contentsection" className="contentarea" >
					<div className="inner-title-bg journey-tit-bg">
							<h1>
									<span>
											<img src={process.env.PUBLIC_URL+"/images/ask_ecoach_img.jpg"} align="absmiddle" alt="" border="0"/>
									</span>Ask E Coach <img src={process.env.PUBLIC_URL+"/images/ecoach-men.png"}  alt="" className="ecoach-men" align="absmiddle" border="0" /><br/>
									<span className="subtitle">Ask questions, clarify doubts</span>
							</h1>
					</div>

					<div className="myperformance e-coach">
					  <section id="semana-scroll-inner" className="scroll">
					    <section className="viewport">
					      <section className="overview">
					        <div className="inner-content">
										<div style={{display: 'block',width: '100%'}} id="parentHorizontalTab">
											<ul className="resp-tabs-list hor_1 horizontaltabbg">
												<li >FAQs<div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" border="0" /></div></li>
												<li >Ask a Question<div className="activearrow"><img  src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" border="0" /></div></li>
					        			<li >View Answers &amp; Rate<div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" border="0" /></div></li>
											</ul>
											<div className="resp-tabs-container hor_1 ">
					        			<div style={{display:'block'}} className="tab-content">
					                <div className="accordion_coach1 smk_accordion acc_with_icon">
														<div id="divQuestion"></div>
															<div className="orng-box-ecoach">Please find below the Frequently Asked Questions. If you cannot find your answer here please click on the "Ask a Question" tab.</div>
																{faqcontent}
					 									</div>
					       					</div>

					        <div className="tab-content">
					        	<form name="qtoec_form" id="qtoec_form" action="javascript:void(0);" onSubmit={(e) =>this.fnAskquestionSubmit()} method="post">
					                          {/* <p>Would you like to post this question in Discussion forum or privately ask the E Coach?</p> */}
																		<div className="ecoach-btn-rgt">
																		{/* <a href="javascript:void(0);" target="_blank">
																	           <input value="Post in Discussion Forum" className="forum-btn" name="" alt="Post in Discussion Forum" title="Post in Discussion Forum" type="button" />
																	   </a> */}
                                       <input onClick={(e) =>this.fnAskquestion()} value="Ask E Coach" className="ask-btn" name="" alt="Ask E Coach" title="Ask E Coach" type="button" />
																			 </div>
					                              <div className="line-box">
					                                <img alt="" src={process.env.PUBLIC_URL+"/images/ask_ecoach_line.jpg"}  border="0" />
					                              </div>

					                         <div id="tr_askEC" style={{display: 'none'}}>
																	 <h2 className="title-blue">Ask E Coach</h2>
																	 { (this.state.task_question_count >0) ?
																				 <div>
																				  <textarea name="txtQuestion" id="txtQuestion" placeholder="Enter your Question" />
																					<div id="divQuestionask" className="errornoTM"></div>
																					<div className="send-ecoach-btn">
																					<input type="submit"  style={{height:'40px'}} value="Send to E Coach" name="send" alt="Send to E Coach" title="Send to E Coach" /> </div>
																					<div id="error_qus" style={{display:'none'}} className="errornoTM"><p>Please Enter Your Question.</p></div>
																					</div>
																		:
																			  <div>
																			  <div className="light-graybox"><p>No E Coach assigned yet</p></div>
																				</div>
																	 }
					                         </div>
					                         <div id="sent_askEC" className="success-msg" style={{display:'none'}}>
					                         </div>
					                         </form>
					                    </div>

					                    <div className="tab-content">

															{(faq_questions!='') ?
																<div><h2 className="title-blue">You asked your E Coach :</h2>
																{faq_questions}</div>
																:
																<div className="light-graybox"><p>This page will show up your questions to E Coach and the reply you received. You can rate your E Coach based on the answer.</p></div>
															}
															</div>
														</div>

													</div>
													</div>
					              </section>
					             </section>
					            </section>
					          </div>
								</section>
			);
		}
}

export default Ecoach;



// WEBPACK FOOTER //
// ./src/personal_interactions/ecoach/Ecoach.js